<template>
  <CModal v-if="portId"
          title="Alias Removing"
          color="danger"
          :show="show"
          :centered="true"
          @update:show="$emit('update:show', false)">

    <div class="content">
      <div class="modal-title">
        <h5>Are you sure to remove the following alias?</h5>
        <i v-if="loading" class="fa fa-cog fa-spin fa-2x"></i>
      </div>

      <div class="details-row">
        <div class="details-row__title">Alias name</div>
        <div class="details-row__value">{{ aliasName }}</div>
      </div>
    </div>

    <template #footer>
      <CButton @click="$emit('update:show', false)" color="secondary">
        Cancel
      </CButton>
      <CButton @click="handleRemoveAlias" color="danger">
        Remove
      </CButton>
    </template>

  </CModal>
</template>

<script>

export default {
  name: 'alias-remove-modal',

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    portId: {
      type: Number,
      default: null,
    },
    aliasName: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: 'Aliases',
    },
    removeMethod: {
      type: Function,
      default: () => {
        console.log('remove method is not specified')
      },
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    async handleRemoveAlias() {
      this.loading = true;
      let result = await this.removeMethod({
        portId: this.portId,
        name: this.aliasName,
      });

      if(result.error) {
        this.errors.push('Unknown error');
      } else {
        this.$emit('update', result);
        this.$emit('update:show', false);
      }

      this.loading = false;
    },
  },
}
</script>

<style scoped>

</style>

<style scoped lang="scss">
  .details-row {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dotted #ad0000;

    &__title {
      min-width: 50px;
      padding-right: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__value {
      padding-left: 10px;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      direction: rtl;
      text-align: left;
    }
  }

  .modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    .fa-cog {
      color: #adadad;
    }
  }
</style>
